module.exports = __webpack_public_path__ + "img/advance.dff358e4.png";